import { TextField, TextFieldProps, styled } from "@mui/material"

const TfTextField = styled(TextField)<TextFieldProps>(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: "0px",
  },
}))

export default TfTextField
